import React from 'react';
import { Box } from '@mui/material';
import { radius } from '../../theme';

// iOS "grouped list" form container: a rounded bordered card whose FormRow
// children are automatically separated by dividers, instead of each field
// being its own individually-outlined TextField.
export default function FormSection({ children, sx }) {
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: radius.lg,
        overflow: 'hidden',
        bgcolor: 'background.paper',
        '& > *:not(:last-child)': {
          borderBottom: '1px solid',
          borderColor: 'divider',
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
